/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampDto3 } from '../../models/camp-dto-3';
import { CampTripShowResponse } from '../../models/camp-trip-show-response';

export interface PostCampTripCopy$Params {
  id: string;
      body: CampDto3
}

export function postCampTripCopy(http: HttpClient, rootUrl: string, params: PostCampTripCopy$Params, context?: HttpContext): Observable<StrictHttpResponse<CampTripShowResponse>> {
  const rb = new RequestBuilder(rootUrl, postCampTripCopy.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampTripShowResponse>;
    })
  );
}

postCampTripCopy.PATH = '/v1/camp-trip/{id}/copy';
